import axios from 'axios'
import { redirect } from '@/helpers/index'
import { getToken } from '@/helpers/auth'
import store from '@/store'
// create an axios instance
const request = axios.create({
  baseURL: process.env.VUE_APP_API_DOMAIN, // url = base url + request url
  timeout: 10000, // request timeout
  withCredentials: true
})

request.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = token
    }
    config.headers['Content-Type'] = 'application/json'

    return config
  }
)
request.interceptors.response.use(
  response => {
    return Promise.resolve(response.data)
  },
  error => {
    const res = error.response
    if (res) {
      switch (res.status) {
        case 404:
          redirect('/404')
          break
        case 403:
          redirect('/403')
          break
        case 500:
          redirect('/500')
          break
        case 401:
          store.dispatch('user/logout')
          redirect('/signin')
          break
        default:
          return Promise.reject(res)
      }
    }
  }
)

export default request
